<div #chatContainer class="flex" [ngStyle]="{ height: '87vh' }">
  <div class="resize-handle" (mousedown)="startResize($event)"></div>

  <selfai-platform-chat-threads-panel
    [isVisible]="showThreads"
    [selectedAgent]="selectedAgent"
    (visibilityChange)="onThreadsVisibilityChange($event)"
    (threadSelected)="onThreadSelected($event)"
    (agentSelected)="onAgentSelected($event)"
    (errorOccurred)="onThreadError($event)"
  ></selfai-platform-chat-threads-panel>

  @if (!showThreads) {
    <p-button
      severity="secondary"
      outlined
      class="threads-toggle-fab"
      (onClick)="showThreads = true"
      [pTooltip]="'chat.main.open-ai-workspace' | translate"
      icon="pi pi-database">
    </p-button>
  }

  <div class="chat-container flex flex-column w-full">
    <div class="flex justify-content-between align-items-center p-3 bg-white border-bottom-1 surface-border shadow-1">
      <div class="flex flex-column gap-1">
        <h1 class="text-xl font-semibold text-900 m-0">{{ 'chat.main.ai-chat-assistant' | translate }}</h1>
        <div class="flex align-items-center gap-2 text-sm" [ngClass]="{'text-green-600': isAgentHealthy && !isProcessing, 'text-orange-500': isProcessing}">
          <span class="w-2 h-2 border-circle" [ngClass]="{'bg-green-500': isAgentHealthy && !isProcessing, 'bg-orange-400': isProcessing, 'bg-red-500': !isAgentHealthy && !isProcessing}"></span>
          @if (isProcessing) {
            <span>{{ 'chat.main.processing' | translate }}</span>
          } @else {
            <span>{{ isAgentHealthy ? ('chat.main.agent-ready' | translate) : ('chat.main.agent-unavailable' | translate) }}</span>
          }
        </div>
      </div>

      <div class="flex gap-3 align-items-center">
        <div class="context-block">
          @if (jsonDataInput.length > 0) {
            <div class="flex align-items-center gap-2 p-2 border-round text-sm font-medium bg-green-50 border-1 border-green-200 text-green-700">
              <i class="pi pi-link text-green-600"></i>
              <span>{{ 'chat.main.context-active' | translate }}</span>
              <div class="flex gap-1 ml-auto">
                <p-button
                  icon="pi pi-eye"
                  (onClick)="viewContext()"
                  [pTooltip]="'chat.main.view-context' | translate"
                  [text]="true"
                  size="small"
                  class="text-blue-600">
                </p-button>
                <p-button
                  icon="pi pi-times"
                  (onClick)="clearContext()"
                  [pTooltip]="'chat.main.clear-context' | translate"
                  [text]="true"
                  size="small"
                  class="text-red-600">
                </p-button>
              </div>
            </div>
          } @else {
            <div class="flex align-items-center gap-2 p-2 border-round text-sm font-medium bg-gray-50 border-1 border-gray-200 text-gray-600">
              <i class="pi pi-unlink text-gray-500"></i>
              <span>{{ 'chat.main.no-context' | translate }}</span>
            </div>
          }
        </div>
      </div>
    </div>

    @if (agentError) {
      <p-message
        severity="error"
        [text]="agentError"
        class="m-2">
      </p-message>
    }

    @if (currentAppName$ | async; as appName) {
      <div class="flex justify-content-between align-items-center p-3 bg-blue-50 border-bottom-1 border-blue-100 text-sm">
        <div class="flex align-items-center gap-2 text-blue-700 font-medium">
          <i class="pi pi-robot text-base"></i>
          <span>{{ 'chat.main.using-agent' | translate:{ agentName: appName } }}</span>
        </div>
      </div>
    }

    <div class="flex-1 flex flex-column min-h-0">
      <selfai-platform-chat-messages-list
        [messages$]="messages$"
        [isProcessing$]="isProcessing$"
        [selectedAgent]="selectedAgent"
        (codeEditorRequested)="openCodeInEditor($event)"
      ></selfai-platform-chat-messages-list>
    </div>

    <div class="flex-shrink-0 border-top-1 surface-border bg-white">
      <selfai-platform-chat-message-input
        [selectedAgent]="selectedAgent"
        [isProcessing]="isProcessing"
        [contextData]="jsonDataInput"
        (messageSent)="onMessageSent($event)"
        (contextCleared)="onContextCleared($event)"
        (errorOccurred)="onInputError($event)"
      ></selfai-platform-chat-message-input>
    </div>
  </div>
</div>
